class CartUpsellSlider extends HTMLElement {
  constructor() {
    super();
    this.initSlider();
    this.initAddToCartButtons();
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.sliderInitialized = false;
  }

  initSlider() {
    if (this.sliderInitialized) return;

    const swiperEl = this.querySelector(".swiper");
    if (swiperEl) {
      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: this.querySelector(".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
      });

      this.sliderInitialized = true;
    }
  }

  initAddToCartButtons() {
    this.querySelectorAll(".upsell-add-to-cart").forEach((button) => {
      button.addEventListener("click", () => {
        const variantId = button.dataset.variantId;

        if (!variantId) return;

        button.disabled = true;
        const originalText = button.textContent;
        button.textContent = "Adding...";

        fetch((window.Shopify?.routes?.root || "/") + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: variantId, quantity: 1, sections: ["cart-drawer", "cart-icon-bubble"], sections_url: window.location.pathname }),
        })
          .then((res) => {
            if (!res.ok) throw new Error("Failed to add to cart");
            return res.json();
          })
          .then((data) => {
            document.querySelector("cart-drawer")?.renderContents(data);
          })
          .catch((error) => {
            console.error(error);
            alert("Sorry, there was a problem adding the item to your cart.");
          })
          .finally(() => {
            button.disabled = false;
            button.textContent = originalText;
          });
      });
    });
  }
}

customElements.define("cart-upsell-slider", CartUpsellSlider);

